import { makeAutoObservable } from "mobx"
import { makePersistable } from 'mobx-persist-store';
import { NotificationModel } from "Models/Notification/NotificationModel";
import React from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class ComponentNotifier {

    // Properties
    Notifications: NotificationModel[] | null;

    // Constructors
    constructor(notifications: NotificationModel[]) {
        makeAutoObservable(this);
        makePersistable(this, { name: 'ComponentNotifier', properties: ['Notifications'] });
        this.Notifications = notifications;
    }

    // Actions
    async addNotification(message: string, link: string, image: string) {
        try{
            const notification = new NotificationModel();
            notification.Message = message;
            notification.Link = link;
            notification.ImageUrl = image;
            this.Notifications?.push(notification);
            toast(message);
        }
        catch(error){
            console.log("Error: " + JSON.stringify(error));
        }
    }
}

let componentNotifier: ComponentNotifier = new ComponentNotifier([]);

export function GetComponentNotifier(){
    if (!componentNotifier){
        componentNotifier = new ComponentNotifier([]);
    }
    // console.log("componentNotifier: " + JSON.stringify(componentNotifier));
    return componentNotifier;
}